import { inject, singleton } from "tsyringe";
import { WINDOW } from "../symbols";

@singleton()
export class SessionStorage {
  constructor(
    @inject(WINDOW)
    private readonly window: Window,
  ) {}

  getItem<T>(key: string): T | string {
    const value = this.window.sessionStorage.getItem(key);
    try {
      return JSON.parse(value) as T;
    } catch {
      return value;
    }
  }

  setItem(key: string, input: Dictionary | string): void {
    const value: string =
      input instanceof Object ? JSON.stringify(input) : input;
    this.window.sessionStorage.setItem(key, value);
  }

  removeItem(key: string): void {
    return this.window.sessionStorage.removeItem(key);
  }
}
